export { default } from "../typeof/_index.mjs"